import EventEmitter from 'eventemitter3'
import { ValidEventCallbacks, ValidEventPayload, ValidEventTypes } from 'share/types/events'

const eventEmitter = new EventEmitter()

const Emitter = Object.freeze({
  on: (event: ValidEventTypes, cb: ValidEventCallbacks) => eventEmitter.on(event, cb),
  once: (event: ValidEventTypes, cb: ValidEventCallbacks) => eventEmitter.once(event, cb),
  off: (event: ValidEventTypes, cb: ValidEventCallbacks) => eventEmitter.off(event, cb),
  emit: (event: ValidEventTypes, payload?: ValidEventPayload) => eventEmitter.emit(event, payload)
})

export default Emitter
